"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: Boolean | Object,
    culture: String,
    dateInput: Boolean,
    dates: Array,
    format: String,
    interval: Number,
    max: Date,
    min: Date,
    parseFormats: Array,
    value: String | Date,

    // Events
    change: Function,
    close: Function,
    open: Function
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-dateinputs-vue-wrapper/dist/es/KendoTimePicker/TimePickerProps.js
// module id = 724
// module chunks = 0